import { apiRequest } from "@services/apiClient";

// Unwrap the standard { data: ... } envelope returned by create_response()
const unwrap = (res) => (res && res.data !== undefined ? res.data : res);

export const getSmsLeads = async (page = 1, perPage = 25, status = "", search = "") => {
  const params = new URLSearchParams();
  params.set("page", page);
  params.set("per_page", perPage);
  if (status) params.set("status", status);
  if (search) params.set("search", search);

  const res = await apiRequest({
    method: "GET",
    endpoint: `/sms/leads?${params.toString()}`,
  });
  return unwrap(res);
};

export const createSmsLead = async (phoneNumber, startSequence = false) => {
  const res = await apiRequest({
    method: "POST",
    endpoint: "/sms/leads",
    body: { phone_number: phoneNumber, start_sequence: startSequence },
  });
  return unwrap(res);
};

export const getSmsLead = async (leadId) => {
  const res = await apiRequest({
    method: "GET",
    endpoint: `/sms/leads/${leadId}`,
  });
  return unwrap(res);
};

export const updateSmsLead = async (leadId, data) => {
  const res = await apiRequest({
    method: "PATCH",
    endpoint: `/sms/leads/${leadId}`,
    body: data,
  });
  return unwrap(res);
};

export const getSmsLeadMessages = async (leadId) => {
  const res = await apiRequest({
    method: "GET",
    endpoint: `/sms/leads/${leadId}/messages`,
  });
  return unwrap(res);
};

export const submitLeadForm = async (data) => {
  const res = await apiRequest({
    method: "POST",
    endpoint: "/sms/lead-form",
    body: data,
    tokenRequired: false,
  });
  return unwrap(res);
};

export const sendSmsMessage = async (leadId, body) => {
  const res = await apiRequest({
    method: "POST",
    endpoint: `/sms/leads/${leadId}/messages`,
    body: { body },
  });
  return unwrap(res);
};

export const getExcludedNumbers = async (page = 1, perPage = 100) => {
  const params = new URLSearchParams();
  params.set("page", page);
  params.set("per_page", perPage);

  const res = await apiRequest({
    method: "GET",
    endpoint: `/sms/excluded-numbers?${params.toString()}`,
  });
  return unwrap(res);
};

export const addExcludedNumber = async (phoneNumber, reason = "") => {
  const res = await apiRequest({
    method: "POST",
    endpoint: "/sms/excluded-numbers",
    body: { phone_number: phoneNumber, reason: reason || null },
  });
  return unwrap(res);
};

export const removeExcludedNumber = async (phoneNumber) => {
  const res = await apiRequest({
    method: "DELETE",
    endpoint: `/sms/excluded-numbers/${encodeURIComponent(phoneNumber)}`,
  });
  return unwrap(res);
};
